import { IEnvironment } from "../interfaces";

type EnvironmentFilterableStringProps = Omit<
  IEnvironment,
  | "isLive"
  | "uatDate"
  | "prodDate"
  | "additionalDomains"
  | "url"
  | "isoCode"
  | "priority"
  | "cluster"
>;

type EnvironmentFilterableDateProps = Pick<
  IEnvironment,
  "uatDate" | "prodDate"
>;

type EnvironmentFilterableNumberProps = Pick<IEnvironment, "priority">;

const NO_DATE_KEY = "n/a";
const NA_COMPARE_DATE = "12/2222";

export const ENVIRONMENTS_FILTERS = {
  stringFilter: (prop: keyof EnvironmentFilterableStringProps) => {
    return (firstEnv: IEnvironment, secondEnv: IEnvironment) =>
      firstEnv[prop]?.localeCompare(secondEnv[prop]);
  },
  numberFilter: (prop: keyof EnvironmentFilterableNumberProps) => {
    return (firstEnv: IEnvironment, secondEnv: IEnvironment) =>
      firstEnv?.[prop] - secondEnv?.[prop];
  },
  dateFilter: (prop: keyof EnvironmentFilterableDateProps) => {
    return (firstEnv: IEnvironment, secondEnd: IEnvironment) => {
      let firstEndDate = firstEnv?.[prop];
      let secondEndDate = secondEnd?.[prop];

      if (firstEndDate?.includes(NO_DATE_KEY)) {
        firstEndDate = NA_COMPARE_DATE;
      }

      if (secondEndDate?.includes(NO_DATE_KEY)) {
        secondEndDate = NA_COMPARE_DATE;
      }

      const [firstEnvMonth, firstEnvYear] = firstEndDate?.split("/");
      const [secondEnvMonth, secondEnvYear] = secondEndDate?.split("/");

      return (
        new Date(Number(firstEnvYear), Number(firstEnvMonth)).getTime() -
        new Date(Number(secondEnvYear), Number(secondEnvMonth)).getTime()
      );
    };
  },
};
